export default {
  "root": "_root_192yx_1",
  "table": "_table_192yx_1",
  "row": "_row_192yx_1",
  "cell": "_cell_192yx_1",
  "head": "_head_192yx_1",
  "body": "_body_192yx_1",
  "cell--align-start": "_cell--align-start_192yx_1",
  "cell--align-center": "_cell--align-center_192yx_1",
  "cell--align-end": "_cell--align-end_192yx_1",
  "cell--valign-start": "_cell--valign-start_192yx_1",
  "cell--valign-center": "_cell--valign-center_192yx_1",
  "cell--valign-end": "_cell--valign-end_192yx_1",
  "cell--width-auto": "_cell--width-auto_192yx_1",
  "--row-highlighted": "_--row-highlighted_192yx_1",
  "--border-outer": "_--border-outer_192yx_1",
  "--border-column": "_--border-column_192yx_1",
  "--fade-start": "_--fade-start_192yx_1",
  "--fade-end": "_--fade-end_192yx_1"
};import "ni:sha-256;5uzFXhEa8cMfU9zEXwRtWznLBlKu0XcFAUtcrgGiL8A";